import { Localytics } from '@gasbuddy/dom-telemetry';
import logEvent from './logEvent';

export const CUSTOM_DIMENSIONS = {
  USER_ID: 14,
  USER_NAME: 15,
};

Localytics.on('event', (eventName, eventAttributes) => {
  logEvent(`Localytics:${eventName}`, eventAttributes);
});

export default Localytics;
